/**
 * Build a consistent featureKey string.
 * If `id` is passed, returns "feature:id", otherwise just "feature".
 */
export function loadingKey(feature: string, id?: string) {
  return id != null ? `${feature}:${id}` : feature;
}

export const loadingKeys = {
  FAVORITE_BUTTON: 'FavoriteButton',
  FETCH_TENDER_DATA: 'FetchTenderData',
  REFRESH_SINGLE_TENDER: 'RefreshSingleTender',
};
